// src/constants/wfFlagReasons.js
//
// The escalation vocabulary. Mirrors aiprime.wf_flag_reason (migration 043) and
// FLAG_REASONS in admin-api/lib/wellfinder/adjudication.js — the server is the
// authority and 400s an unknown value; this exists so the analyst picks from a
// list rather than typing prose the supervisor then has to interpret.
//
// ── THESE SAY WHY YOU ARE ESCALATING, NOT WHAT THE VERDICT IS ────────────────
//
// Reject reasons already cover verdicts. A value here that reads like one would
// invite deciding in the flag instead of handing over, which is the opposite of
// what flagging is for.
//
// DELIBERATELY ABSENT: "equipment type unclear". Tier A handles that without
// escalating, and offering it here would route records to a supervisor that do
// not need one.
//
// The long labels are the point. A supervisor reading the flagged queue is
// reading these, not the enum values, and "Structure present, can't identify it
// as a wellhead" tells them what to look at in a way "structure_ambiguous"
// does not.

export const WF_FLAG_REASONS = [
  ["imagery_unclear", "Imagery unclear — shadow, resolution, obstruction"],
  ["structure_ambiguous", "Structure present, can't identify it as a wellhead"],
  ["candidates_equal", "Two or more registry matches, no basis to choose"],
  ["registry_conflict", "Candidate data contradicts what's visible"],
  ["possible_duplicate", "May be the same wellhead as an adjacent detection"],
  ["other", "Other"],
];

/** The one value that cannot stand alone — the server requires a note with it. */
export const WF_FLAG_REASON_REQUIRING_NOTE = "other";

export const WF_FLAG_REASON_LABEL = Object.fromEntries(WF_FLAG_REASONS);

/** Short form, for a dense list where the full sentence would wrap. */
export const WF_FLAG_REASON_SHORT = {
  imagery_unclear: "Imagery unclear",
  structure_ambiguous: "Structure ambiguous",
  candidates_equal: "Candidates equal",
  registry_conflict: "Registry conflict",
  possible_duplicate: "Possible duplicate",
  other: "Other",
};
